import { render, staticRenderFns } from "./TabRetroalimentacion.vue?vue&type=template&id=63fb4712&scoped=true&"
import script from "./TabRetroalimentacion.vue?vue&type=script&lang=js&"
export * from "./TabRetroalimentacion.vue?vue&type=script&lang=js&"
import style0 from "./TabRetroalimentacion.vue?vue&type=style&index=0&id=63fb4712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb4712",
  null
  
)

export default component.exports